import { Directive, ElementRef, Input, Renderer } from '@angular/core';

@Directive({
    selector: '[appMaiusculoMinisculoDirective]'
})
export class MaiusculoMinusculoDirective {

    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer
    ) {
        this._renderer.setElementStyle(this._elementRef.nativeElement, 'text-transform', 'uppercase')
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/directives/maiusculo-minusculo.directive.ts